"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theme = require("../../theme");

var _Arrow = _interopRequireDefault(require("../../assets/svg/Arrow"));

var _Wrapper = _interopRequireDefault(require("./Wrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var HalfBgButton = function HalfBgButton(props) {
  return /*#__PURE__*/_react.default.createElement(_Wrapper.default, _extends({
    onClick: props.onClick
  }, props), /*#__PURE__*/_react.default.createElement("span", null, props.label), /*#__PURE__*/_react.default.createElement(_Arrow.default, null), /*#__PURE__*/_react.default.createElement(_Arrow.default, null));
};

HalfBgButton.propTypes = {
  label: _propTypes.default.string,
  width: _propTypes.default.number,
  height: _propTypes.default.number,
  onClick: _propTypes.default.func,
  fontColor: _propTypes.default.string,
  fontWeight: _propTypes.default.oneOf(["100", "200", "300", "400", "500", "600", "700", "800", "900"]),
  hoverFontColor: _propTypes.default.string,
  backgroundColorOne: _propTypes.default.string,
  backgroundColorTwo: _propTypes.default.string,
  icon: _propTypes.default.string,
  iconPosition: _propTypes.default.string,
  iconDirection: _propTypes.default.string,
  iconFill: _propTypes.default.string
};
HalfBgButton.defaultProps = {
  label: "Click me",
  width: 130,
  height: 40,
  onClick: undefined,
  fontColor: _theme.theme.button.halfBg.fontColor,
  fontWeight: "700",
  hoverFontColor: _theme.theme.button.halfBg.hoverFontColor,
  backgroundColorOne: _theme.theme.button.halfBg.bgColor1,
  backgroundColorTwo: _theme.theme.button.halfBg.bgColor2,
  icon: "arrow",
  iconPosition: "right",
  iconDirection: "right",
  iconFill: _theme.theme.button.halfBg.iconFill
};
var _default = HalfBgButton;
exports.default = _default;